import React from "react"
import Modal from "../../../_components/Modal"
import Text from "../../../_components/Text"
import Button from "../../../_components/Button"
export default (props) => {
    function onHide(){
        if(props.onHide){
            props.onHide()
        }
    }
    return(
        <Modal
        title="ATENÇÃO"
        show={props.show}
        onHide={props.onHide}
            >
            <div>
                
        <Text className="my-8" color="primary">
        No Brasil não existe uma legislação sobre o uso de código de barras sem registro.
         Porém, algumas empresas precisam ter códigos registrados e exclusivos,
        por conta do controle logístico necessário (indicamos a GS1).
        </Text>
        <Text className="my-8" color="primary">
        Para vendas onde o código único internacional não é obrigatório,
        você pode usar os códigos gerados nesse sistema que é válido em qualquer
        leitor de código de barras. Ele vai servir para controle de vendas
        e cadastro nos locais onde deseja comercializar.
        </Text>
        <Text className="my-8" color="primary">
        No Brasil e no mundo, a GS1 é a única que pode gerar códigos internacionais e únicos.
         Faremos o possível para que o código gerado aqui não seja usado por outra pessoa em
          outro lugar, contudo isso não será garantido de nenhuma forma. Bons negócios.
        </Text>
        <Text className="my-8" color="primary">
        *Importante: Por não gerarmos códigos GS1, os mesmos não poderão ser usados no campo GTIN da nota fiscal.
        </Text>

        <Button onClick={() => onHide()} className="my-3">Estou ciente disso</Button>
              </div>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/createWarningModal.jsx